import { Component, OnInit, Input, OnChanges, EventEmitter, Output } from '@angular/core';

import { EntityPagedRequestParameters, EntityOrderedRequestParameters } from "@bndes/bndes-ux4/bndes-angular-utils";
import { Cobranca, TIPO_COBRANCA } from 'src/app/model/cobranca.model';
import { FileUtilsService } from 'src/app/shared/file-utils.service';
import { CobrancaService } from './cobranca.service';


@Component({
    selector: 'app-cobranca-listagem',
    templateUrl: './cobranca-listagem.component.html',
    standalone: false
})
export class CobrancaListagemComponent {

  @Input() public cobrancas: Cobranca[];
  @Input() public atributosPaginacao: EntityPagedRequestParameters;
  @Input() public ehAgenteFinanceiro: boolean;
  @Output() public aoMudarPagina: EventEmitter<EntityPagedRequestParameters> = new EventEmitter<EntityPagedRequestParameters>();

  private tiposCobranca = TIPO_COBRANCA;

  constructor(private fileUtils: FileUtilsService,
                private service: CobrancaService) {
  }

  ngOnInit() {
    if (!this.atributosOrdenacao){
      this.atributosOrdenacao = {
        atributo: '',
        sentido: 'asc'
      }
    }
  }

  public opcoesPaginacao: number[] = [10, 15, 20];
  public atributosOrdenacao: EntityOrderedRequestParameters;

  mudancaPagina(novaPagina: EntityPagedRequestParameters) {
    this.atributosPaginacao = novaPagina;
    this.aoMudarPagina.emit(novaPagina);
  }

  exportarBoleto(cobranca: Cobranca) {
    this.service.getBoleto(cobranca.id).subscribe((conteudoBoleto) => {
        this.fileUtils.exportarArquivo('Boleto_' + cobranca.codigoCobranca + '.pdf', conteudoBoleto, FileUtilsService.APPLICATION_PDF);
    });
  }

  mudancaOrdenacao(novaOrdenacao: EntityOrderedRequestParameters) {
    this.atributosOrdenacao = novaOrdenacao;
    this.pesquisarOrdenacao(this.atributosOrdenacao);
  }

  pesquisarOrdenacao(ord: EntityOrderedRequestParameters) {
    this.cobrancas = this.cobrancas.sort((a, b) => {
      if (ord.sentido == "asc") {
        return this.compara(a, b, ord.atributo);
      }
      else {
        return -1 * this.compara(a, b, ord.atributo);
      }
    });
  }

  private compara(a, b, atributo): number {
    if (this.fetchFromObject(a, atributo) == this.fetchFromObject(b, atributo)) {
      return 0;
    }
    else {
      if (this.fetchFromObject(a, atributo) > this.fetchFromObject(b, atributo)) {
        return 1;
      }
      else {
        return -1;
      }
    }
  }

  private fetchFromObject(obj, prop) {

    if(typeof obj === 'undefined') {
      return false;
    }

    var _index = prop.indexOf('.')
    if(_index > -1) {
        return this.fetchFromObject(obj[prop.substring(0, _index)], prop.substr(_index + 1));
    }

    return obj[prop];
  }

  obterTipoCobranca(codigo:string):string{
    return this.tiposCobranca.filter(tipo=> tipo.codigo.includes(codigo))[0].labelAbreviado;
}

}
